import { Col } from 'antd';
import { ProgramCategoryEnumComponent } from '../../../../enumComponent/ProgramCategoriesComponent/ProgramCategoriesComponent';
import { Program } from '../../../../uc-api-sdk';
import EmptyComponent from '../../../../uiComponent/EmptyComponent/EmptyComponent';
import { PatientProfileDateDisplayComponent } from '../PatientProfileDateDisplayComponent/PatientProfileDateDisplayComponent';
import { EnrolledProgramService } from '../../../../services/EnrolledProgramService';
import { MissingErrorComponent } from '../../../../uiComponent/MissingErrorComponent/MissingErrorComponent';

export interface PatientProfileProgramEnrollmentItemComponentProps {
  programEnrollment: Program;
}

export const PatientProfileProgramEnrollmentItemComponent = ({
  programEnrollment,
}: PatientProfileProgramEnrollmentItemComponentProps) => {
  if (!programEnrollment.category) {
    return <EmptyComponent />;
  }

  const isPendingProgram = EnrolledProgramService.isProgramPending(programEnrollment);
  const programStartDate = programEnrollment.startDate || programEnrollment.createdAt;

  return (
    <div className="flex f-w jc-sb mb20">
      <Col span={14}>
        <ProgramCategoryEnumComponent
          value={programEnrollment.category}
          type="long"
        />
      </Col>
      <Col span={9}>
        {
          isPendingProgram
            ? (
              <MissingErrorComponent icon={null}>
                Pending
              </MissingErrorComponent>
            ) : (
              <PatientProfileDateDisplayComponent
                value={programStartDate}
                label="Started on"
              />
            )
        }
      </Col>
    </div>
  );
};
